var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#1B69FF",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2593 16.24V16.52H25.5793V18.16H23.1393C22.9926 19.0533 22.7126 19.7667 22.2993 20.3C21.8993 20.82 21.326 21.2 20.5793 21.44C19.8326 21.6667 18.866 21.78 17.6793 21.78V23.04C17.6793 23.7733 17.8326 24.3533 18.1393 24.78C18.4593 25.2067 18.9926 25.42 19.7393 25.42C21.0993 25.42 21.7793 24.6533 21.7793 23.12H23.8793C23.866 24.4667 23.4993 25.4867 22.7793 26.18C22.0726 26.86 21.046 27.2 19.6993 27.2C18.3526 27.2 17.3193 26.8267 16.5993 26.08C15.8926 25.3333 15.5393 24.2867 15.5393 22.94V20.2C17.0193 20.2 18.106 20.16 18.7993 20.08C19.4926 19.9867 20.006 19.8 20.3393 19.52C20.686 19.24 20.9126 18.7867 21.0193 18.16H14.6993V16.52H21.1193V16.24V14.74H14.6993V13.08H25.5793V14.74H23.2593V16.24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRupee);
export default __webpack_public_path__ + "static/media/ic_rupee.5fd55ef0eb7980175a56e4c24ad1f34f.svg";
export { ForwardRef as ReactComponent };